/**
 * Created by staffanrantzow on 12/04/16.
 */

export default class ProfessionEntity {

  constructor (
    id,
    insuranceStatusId,
    languageId,
    ssyk,
    title
  ) {
    this.id = id;
    this.insuranceStatusId = insuranceStatusId;
    this.languageId = languageId;
    this.ssyk = ssyk;
    this.title = title;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/professions/profession-entity.js
 **/